/* src/app/shared/components/ag-drop-down/ag-multiple-box/ag-multiple-box.component.scss */
.additional-charges-form {
  background-color: #ffffff;
  width: 95%;
  height: 45px;
  padding-inline-start: 8px;
  padding-top: 3px;
  font-family: "Poppins-Regular";
  font-size: 14px;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #222222;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding-right: 24px;
  padding-left: 15px;
  margin-bottom: 0;
  border-radius: 16px;
  display: flex;
  align-items: center;
}
.flex {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
}
.disable-selection {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.container-standard {
  padding-left: 0px;
  position: inherit;
  z-index: 2;
  max-height: 100%;
  height: fit-content;
  width: 100%;
  min-width: 82px;
  border-radius: 12px;
  box-shadow: 0 3px 8px 0 rgba(140, 140, 140, 0.5);
  border: solid 1px #dfdfdf;
  background-color: #ffffff;
  overflow: hidden;
}
.container-fixed {
  padding-left: 0px;
  padding-right: 8px;
  position: fixed;
  z-index: 1010;
  max-height: 100%;
  height: fit-content;
  border-radius: 8px;
  box-shadow: 0 3px 8px 0 rgba(140, 140, 140, 0.5);
  border: solid 1px #dfdfdf;
  background-color: #ffffff;
}
.header {
  padding-left: 16px;
  font-family: Lato;
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #222222;
}
.items-container {
  width: 100%;
}
.item-container {
  width: 100%;
  padding-right: 16px;
  padding-left: 16px;
}
.hovering-item {
  width: 100%;
  padding-right: 16px;
  padding-left: 16px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.hovering-item:hover,
.hovering-item:hover .item {
  background-color: #f2f2f2;
}
.item {
  width: 100%;
  height: 33px;
  background-color: #ffffff;
  cursor: pointer;
  position: relative;
  display: flex;
  flex-direction: row;
  gap: 12px;
}
.disabled-item {
  width: 100%;
  height: 33px;
  background-color: #ffffff;
  position: relative;
  display: flex;
  flex-direction: row;
  gap: 12px;
  opacity: 0.5;
  cursor: not-allowed;
  background-color: transparent;
}
.title {
  font-family: "Poppins-SemiBold";
  font-size: 14px;
  font-style: normal;
  line-height: 24px;
  color: #222222;
  margin-bottom: 0;
}
.item-text {
  position: relative;
  top: 4px;
  vertical-align: sub;
  font-family: "Poppins-Regular";
  font-style: normal;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: normal;
  color: #333333;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: calc(100% - 12px);
  cursor: pointer;
}
.select-all-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 84px;
}
.spacer {
  padding-bottom: 8px;
}
.top-bottom-padding {
  margin-bottom: 5px;
  padding-bottom: 16px;
  height: fit-content;
  display: block;
  overflow-y: scroll;
  overflow-x: hidden;
}
.top-bottom-padding::-webkit-scrollbar-thumb {
  background-color: #a6a6a6;
  border-radius: 100px;
  width: 8px;
  height: 10px;
}
.top-bottom-padding::-webkit-scrollbar-track {
  background-color: #f2f2f2;
}
.form-div {
  position: relative;
  width: 100%;
  padding: 12px 12px 0px 12px;
}
.search-bar {
  display: flex;
  flex-direction: row-reverse;
  gap: 12px;
  padding: 12px 8px 12px 8px;
  background-color: #f2f2f2;
  border-radius: 12px;
  width: 100%;
  height: 40px;
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 8px;
}
.form-img {
  height: 20px;
  width: 20px;
  opacity: 0.5;
}
.code-changeable-img {
  position: absolute;
  right: 8px;
  top: 15px;
  transform: rotate(-180deg);
}
.search-bar-input {
  width: 95%;
  float: right;
  font-size: 14px;
  border: none;
  background-color: #f2f2f2;
  overflow: hidden;
  text-overflow: ellipsis;
  height: 20px;
}
input:focus {
  outline: none;
}
:-ms-input-placeholder {
  font-family: "Poppins-Regular";
  font-size: 14px;
  line-height: 24px;
  color: #a6a6a6;
}
::placeholder {
  font-family: "Poppins-Regular";
  font-size: 14px;
  line-height: 24px;
  color: #a6a6a6;
}
.no-result-text {
  color: #a6a6a6;
  text-align: center;
  font-size: 12px;
  line-height: 16px;
  font-family: "Poppins-Regular";
}
input:focus {
  outline: none;
}
.line-container {
  padding: 0px 16px;
}
.line {
  width: 100%;
  height: 1px;
  background-color: #dfdfdf;
  margin-bottom: 8px;
  margin-top: 8px;
}
.checkbox {
  padding-right: 12px;
  pointer-events: none;
  height: 20px;
  width: 30px;
}
::-webkit-scrollbar {
  width: 5px;
}
::-webkit-scrollbar-thumb {
  background: #dfdfdf;
  border-radius: 3px;
  padding: 16px 13px;
}
.radio-button {
  accent-color: #222222;
}
.img {
  pointer-events: none;
  height: 20px;
  width: 20px;
}
.divider {
  height: 1px;
  width: 100%;
  background-color: #dfdfdf;
  margin: 4px 16px;
}
/*# sourceMappingURL=ag-multiple-box.component.css.map */
